import Select from 'react-select';
import React from "react";
import { Form } from 'react-bootstrap';
import { IListOption } from "../classes/Domain";
import * as _ from 'lodash';
import { slectColourStyles } from "../AppConstants";


interface ISelectListProps {
    label: string,
    value: string,
    className?: string,
    placeholder?: string | null,
    validated: boolean,
    validationError: string,
    disabled?: boolean,
    selectOptions: Array<IListOption>,
    onChange?: (selectedValue: IListOption | null) => void;
}

interface IState {
    selectedValue: IListOption | null
}

export class SelectList extends React.Component<ISelectListProps, IState> {
    constructor(props: ISelectListProps) {
        super(props);

        this.onStateChange = this.onStateChange.bind(this);

        this.state = {
            selectedValue : null
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.value && !prevState.value) {
            const state = _.find(nextProps.selectOptions, ['value', nextProps.value]);
            return state
                ? {
                    ...prevState,
                    selectedValue: state
                  }
                : prevState;
        }

        return prevState;
    }

    onStateChange(value: IListOption | null) {
        this.setState({ selectedValue: value }, () => {
            if (this.props.onChange) {
                this.props.onChange(value);
            }
       });
    }

    render() {
        return (
            <Form.Group className={this.props.className}>
                <Form.Label>{this.props.label}</Form.Label>
                <Select
                    options={this.props.selectOptions}
                    value={this.state.selectedValue}
                    placeholder={this.props.placeholder ? this.props.placeholder : "Please select..." }
                    onChange={(v) => this.onStateChange(v ? { label: v["label"], value: v["value"] }: null)}
                    isDisabled ={this.props.disabled}
                    className={this.props.validated ? (this.props.validationError ? "is-invalid" : "is-valid") : ""}
                    styles={slectColourStyles}
                    isClearable={false} />
                {this.props.validated && this.props.validationError
                    ? <Form.Control.Feedback type="invalid">
                        {this.props.validationError}
                    </Form.Control.Feedback>
                    : null
                }
            </Form.Group>
        );
    }
}

export default SelectList;